import { Header } from "./style";

// Libs
import Translation from 'libs/Translation';
import ModalManager from 'libs/ModalManager';
import lodashDebounce from 'lodash.debounce';

// Components
import Text from 'components/common/Text';
import Image from 'next/image';
import Button from 'components/common/Button';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import Link from 'components/common/Link';
import FreeTimesCalendar from 'components/common/FreeTimesCalendar';

const MedicalTeamCard = ({ center, doctor, webConfig }) => {

    const handleDebouncedOpenCalendar = lodashDebounce(() => {DebouncedOpenCalendar()}, 100)

    const DebouncedOpenCalendar = () => {
        ModalManager.show({
            content: 
                <FreeTimesCalendar 
                    doctor={doctor?.HealthWorkerProfiles[0]}
                    webConfig={webConfig} 
                    hideBookButton={true}
                    nextStepButton={true}
                    healthProviderId={center?.HealthProvider}
                />,
                    title: 
                        <Header>
                            <Image
                                src={doctor?.HealthWorkerProfiles[0]?.profileImage ? doctor?.HealthWorkerProfiles[0].profileImage?.fileUrl : "/nextasset/images/center/avatar.png"}
                                alt={`${doctor?.HealthWorkerProfiles[0]?.Label} ${doctor?.HealthWorkerProfiles[0]?.FullName}`}
                                width={58}
                                height={58}
                                className="img"
                            />
                            <div className='column-flex'>
                                <Text
                                    className="name"
                                >
                                    {doctor?.HealthWorkerProfiles[0]?.Label ?? ''} {doctor?.HealthWorkerProfiles[0]?.FullName}
                                </Text>
                                {doctor?.HealthWorkerProfiles[0]?.Specialties?.length ?
                                <Text
                                    className='specialties'
                                >  
                                {doctor.HealthWorkerProfiles[0]?.Specialties.map((s, i) => 
                                <>
                                    {Translation.t('label.specialty-education', {degree: s.Label, specialty: s.Name})}
                                    {i !== doctor.HealthWorkerProfiles[0]?.Specialties.length - 1 &&
                                    <>
                                    <span>{Translation.t(',')}</span>
                                    {' '}
                                    </>
                                    }
                                </>
                                )}
                                </Text>
                            : null}  
                            </div>
                        </Header>,
                    maxWidth: 'sm',
                    background: '#F5F5F7',
                    fullScreenMobile: true,
                    hideCloseButton: false,
                    closable: true,
                })
    }
    
    const handleOpenCalendar = () => {
        ModalManager.hide();

        handleDebouncedOpenCalendar();
    }

    return (
    <div className='medical-team-card'>
        <div className='header width-100 align-items-center'>
            <Link 
                className="doctor-image"
                to={`/dr/${doctor?.HealthWorkerProfiles[0]?.Slug}`}
                params={webConfig.lang !== 'fa' ? {lang: webConfig.lang} : {}}
            >
                <Image
                    src={doctor?.HealthWorkerProfiles[0]?.profileImage ? doctor?.HealthWorkerProfiles[0].profileImage.fileUrl : "/nextasset/images/center/avatar.png"}
                    alt={`${doctor?.HealthWorkerProfiles[0]?.Label} ${doctor?.HealthWorkerProfiles[0]?.FullName}`}
                    width={90}
                    height={90}
                    className='img'
                />
            </Link>
            <div className='column-flex flex-start gap-5 width-auto'>
                <Text 
                    className="name"
                    tag="h2"
                >
                   {doctor?.HealthWorkerProfiles[0]?.Label ?? ''} {doctor?.HealthWorkerProfiles[0]?.FullName}
                </Text>
                {doctor?.Specialties?.length ?
                <div
                    className="label"
                >
                    {doctor?.Specialties.map((s, i) => 
                    <>
                        {Translation.t('label.specialty-education', {degree: s.EducationLevel, specialty: s.Specialty})}
                        {i !== doctor?.Specialties.length - 1 &&
                        <>
                        <span>{Translation.t(',')}</span>
                        {' '}
                        </>
                        }
                    </>
                    )}
                    </div>
                : null
                }
            </div>
        </div>
        <div className="column-flex flex-start width-100 gap-10">
            <div className="row-flex gap-5">
                <span>
                    {Translation.t('title.services')}:
                </span>
                {doctor?.HealthWorkerProfiles[0]?.Services?.length ?
                <div
                    className="label"
                >
                    {doctor.HealthWorkerProfiles[0]?.Services.map((s, i) => 
                    <>
                        {s}
                        {i !== doctor.HealthWorkerProfiles[0]?.Services.length - 1 &&
                        <>
                        <span>{Translation.t(',')}</span>
                        {' '}
                        </>
                        }
                    </>
                    )}
                    </div>
                : null
                }
            </div>
        </div>
        <Button 
            onClick={handleOpenCalendar}
            className="width-100"
        >
            <div 
                className="book-button"
            >
                {Translation.t('label.book-appt')}
                <KeyboardBackspaceIcon 
                    style={{ width: "24px", height: '24px' }}
                    className='arrow'
                />
            </div>
        </Button>
    </div>
    )
}
export default MedicalTeamCard;